let mouseInSide = false;

const openSide = () => {
  document.querySelector('.collumns').style["grid-template-columns"] = "100%"
  document.querySelector('.right-left').style.right = "2px"
  document.querySelector('.click-left').style.display = 'none'
  document.querySelector('.click-left-stay').style.display = 'block'
  document.querySelector('.click-right').style.display = 'none'
  document.querySelector('.form-loss').style.display = 'none'
}

const closeSide = () => {
  document.querySelector('.collumns').style["grid-template-columns"] = "1fr 360px"
  document.querySelector('.right-left').style.right = "362px"
  document.querySelector('.click-right').style.display = 'block'
  document.querySelector('.click-left').style.display = 'none'
  document.querySelector('.click-left-stay').style.display = 'none'
  document.querySelector('.form-loss').style.display = 'block'
  mouseInSide = false
}

const showSide = () => {
  closeSide()
  mouseInSide = true
  document.querySelector('.click-left-stay').style.display = 'block'
  document.querySelector('.click-right').style.display = 'none'
}

const hideSide = () => {
  if(mouseInSide){
    openSide()
    mouseInSide = false
  }
}

export {
  openSide,
  closeSide,
  showSide,
  hideSide
}